<template lang="pug">
  .shipping-step
    .panel.mb-8
      .box
        .shipment-type
          .preview
            .icon
              svg(
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              )
                //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                path(
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.3"
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                )
            .data
              .field-preview
                .label Versandart
                //- TODO
                .field-value Wie vereinbart
        //- TODO
        //- hr.my-4
        //- .shipment-fee
        //-   .preview
        //-     .icon
        //-       svg(
        //-         xmlns="http://www.w3.org/2000/svg"
        //-         fill="none"
        //-         viewBox="0 0 24 24"
        //-         stroke="currentColor"
        //-       )
        //-         path(
        //-           stroke-linecap="round"
        //-           stroke-linejoin="round"
        //-           stroke-width="1.3"
        //-           d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        //-         )
        //-     .data
        //-       .field-preview
        //-         .label Lieferkosten
        //-         //- TODO
        //-         .field-label {{ 0 | moneyFormat(currency) }}
        hr.my-4
        // TODO: multiple addresses / add address
        AddressForm(:form="form" label="Lieferadresse" :show-name="true")
</template>

<script>
import { mapGetters } from 'vuex';
import { get } from '@/helpers';

import AddressForm from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/AddressForm';

export default {
  name: 'ShippingStep',
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  components: {
    AddressForm
  },
  computed: {
    currency() {
      return (
        get(this.customer, 'customerGroup.currency.iso4217') ||
        get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        'EUR'
      );
    },
    ...mapGetters({
      customer: 'shop/customer',
      defaultCustomerGroup: 'shop/defaultCustomerGroup'
    })
  }
};
</script>

<style lang="sass" scoped></style>
